import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';
import { Headers, Http, ResponseContentType } from '@angular/http';
import { AuthService } from './../auth/auth.service';
import { environment } from '../../environments/environment';

@Injectable()
export class AdminReportService {
  public apiUrl = environment.apiUrl;

  constructor(public http: Http, public authService: AuthService) { }

  /*request headers*/
  public createHeaders() {
    const headers = new Headers({ Accept: 'application/json' });
    if (this.authService.isLoggedIn) {
      headers.append('Authorization', 'Bearer ' + this.authService.getToken());
    }
    return headers;
  }

  public getReportFilters() {
    return this.http
      .get(this.apiUrl + '/administrative-reports-filters', {
        headers: this.createHeaders(),
      })
      .toPromise()
      .then(response => response.json() as any);
  }

  public postAdministrativeReports(data) {
    return this.http.post(this.apiUrl + '/administrative-reports', data, {
      headers: this.createHeaders()
    })
    .toPromise()
    .then(response => response.json() as {any});
  }

  public postWeightAdministrativeReports(data) {
    return this.http.post(this.apiUrl + '/administrative-reports-weight', data, {
      headers: this.createHeaders()
    })
    .toPromise()
    .then(response => response.json() as {any});
  }

  public sendMail(body) {
    return this.http.post(this.apiUrl + '/administrative-reports-to-email', body, {
      headers: this.createHeaders()
    })
    .toPromise()
    .then(response => response.json() as {any});
  }

  public sendWeightMail(body) {
    return this.http.post(this.apiUrl + '/administrative-reports-weight-email', body, {
      headers: this.createHeaders()
    })
    .toPromise()
    .then(response => response.json() as {any});
  }

  public downloadReport(data) {
    return this.http.post(this.apiUrl + '/administrative-reports-download', data, {
      headers: this.createHeaders(),
      responseType: ResponseContentType.Blob
    }, )
    .toPromise()
    .then(response => response.blob() as Blob);
  }

  public downloadWeightReport(data) {
    return this.http.post(this.apiUrl + '/administrative-reports-weight-download', data, {
      headers: this.createHeaders(),
      responseType: ResponseContentType.Blob
    }, )
    .toPromise()
    .then(response => response.blob() as Blob);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/admin-report.service.ts